import { createAsyncThunk } from '@reduxjs/toolkit';
import { commonService } from '../../services/common/common.service';
import { showHideLoader } from './common.slice';

// get users list action
const getUsersListAction = createAsyncThunk(
  'salesSlice/getUsersListAction', ( payload, { dispatch, rejectWithValue }) => {
    return commonService.getUsersList()
      .then((response) => {
        return response
      })
      .catch((error: { response: unknown; }) => {
        return rejectWithValue(error?.response)
      })
  }
);

// get labels list action
const getLabelsListAction = createAsyncThunk(
  'salesSlice/getLabelsListAction', ( payload:any, { dispatch, rejectWithValue }) => {
    return commonService.getLabelsList(payload)
      .then((response) => {
        return response
      })
      .catch((error: { response: unknown; }) => {
        return rejectWithValue(error?.response)
      })
  }
);

// post new label action 
const addNewLabelAction = createAsyncThunk(
  'salesSlice/addNewLabelAction', ( payload:any, { dispatch, rejectWithValue }) => {
    return commonService.addNewLabelService(payload)
      .then((response) => {
        return response
      })
      .catch((error: { response: unknown; }) => {
        return rejectWithValue(error?.response)
      })
  }
);

// post new label action 
const getTableauTokenAction = createAsyncThunk(
  'salesSlice/getTableauTokenAction', ( payload:any, { dispatch, rejectWithValue }) => {
    
    dispatch(showHideLoader(true));

    return commonService.getTableauToken()
      .then((response) => {
        
        setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)

        return response
      })
      .catch((error: { response: unknown; }) => {
        
        setTimeout(() => {
          dispatch(showHideLoader(false))
        }, 500)

        return rejectWithValue(error?.response)
      })
  }
);

// add new vendor action 
const addNewVendorAction = createAsyncThunk(
  'salesSlice/addNewVendorAction', ( payload:any, { dispatch, rejectWithValue }) => {
    
    dispatch(showHideLoader(true));

    return commonService.addNewVendorService(payload)
      .then((response) => {
        dispatch(showHideLoader(false));
        return response
      })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false));
        return rejectWithValue(error?.response)
      })
  }
);

// get subs list action

const getSubcontractorsListForTimelineTaskAction = createAsyncThunk(
  'salesSlice/getSubcontractorsListForTimelineTaskAction', ( payload:any, { dispatch, rejectWithValue }) => {
    return commonService.getSubcontractorsListForTimelineTask(payload)
      .then((response) => {
        dispatch(showHideLoader(false));
        return response
        })
      .catch((error: { response: unknown; }) => {
        dispatch(showHideLoader(false));
        return rejectWithValue(error?.response)
      })
  }
);

// export all common actions
export const commonActions = {
    getUsersListAction,
    getLabelsListAction,
    addNewLabelAction,
    getTableauTokenAction,
    addNewVendorAction,
    getSubcontractorsListForTimelineTaskAction
}